"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertStatusCode = function (code) { return code >= 200 && code <= 400; };



//////////////////
// WEBPACK FOOTER
// ./src/shared/http_client.ts
// module id = 266
// module chunks = 2